import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ShoppingCart } from "lucide-react";
 * // Use <ShoppingCart /> instead
 */
export const OrdersIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M2 3.5a1 1 0 0 0 0 2h2.702l2.264 8.961.055.253a1 1 0 0 0 .999.786h9.982a1 1 0 0 0 .977-.786l1.755-7a1 1 0 0 0-.977-1.214H6.98l-.682-3H2ZM11 18.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM17 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  />
);
